@if(isStatic) {
@if(show) {
<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[500]"
    (click)="currentClosable && close()" @dialogAnimation>

    <div [ngStyle]="widthStyle" [ngClass]="config.bgColor || 'bg-white dark:bg-slate-900'"
        class="rounded-lg shadow-2xl max-w-full max-h-[90vh] flex flex-col border border-white/10 overflow-hidden"
        (click)="$event.stopPropagation()" @dialogContentAnimation>

        @if(currentTitle || currentClosable) {
        <div class="flex items-center justify-between p-3 px-4 border-b border-foreground/[0.05]">
            <div class="flex flex-col gap-0.5 flex-1 min-w-0">
                <h2 class="text-sm md:text-base font-black text-foreground leading-tight uppercase tracking-tight whitespace-nowrap overflow-hidden text-ellipsis flex items-center gap-2">
                    <iconify-icon *ngIf="currentIcon" [icon]="currentIcon" width="18" height="18"
                        class="text-primary shrink-0 transition-all"></iconify-icon>
                    <span>{{ currentTitle }}</span>
                </h2>
            @if(currentDescription) {
                <p class="text-xs font-medium text-text-muted italic line-clamp-2">{{ currentDescription }}</p>
                }
            </div>
            @if(currentClosable) {
            <button (click)="close()"
                class="w-10 h-10 flex items-center justify-center rounded-xl border border-foreground/[0.08] text-foreground/40 hover:text-primary hover:border-primary/40 hover:bg-primary/5 transition-all">
                <iconify-icon icon="solar:close-square-bold-duotone" width="24" height="24"></iconify-icon>
            </button>
            }
        </div>
        }

        <div class="flex-1 overflow-auto p-4" [ngClass]="config.contentClass">
            <ng-content></ng-content>
        </div>
    </div>
</div>
}
} @else {
@for(d of dialogs(); track d.id) {
<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center" [style.z-index]="d.zIndex"
    (click)="d.currentClosable && closeDialog(d.id)" @dialogAnimation>

    <div [ngStyle]="d.widthStyle" [ngClass]="d.config.bgColor"
        class="rounded-lg shadow-2xl max-w-full max-h-[90vh] flex flex-col border border-white/10 overflow-hidden bg-white dark:bg-slate-900"
        (click)="$event.stopPropagation()" @dialogContentAnimation>

        @if(d.currentTitle || d.currentClosable) {
        <div class="flex items-center justify-between p-3 px-4 border-b border-foreground/[0.05]">
            <div class="flex flex-col gap-0.5 flex-1 min-w-0">
                <h2 class="text-sm md:text-base font-black text-foreground leading-tight uppercase tracking-tight whitespace-nowrap overflow-hidden text-ellipsis flex items-center gap-2">
                    <iconify-icon *ngIf="d.currentIcon" [icon]="d.currentIcon" width="18" height="18"
                        class="text-primary shrink-0 transition-all"></iconify-icon>
                    <span>{{ d.currentTitle }}</span>
                </h2>
            @if(d.currentDescription) {
                <p class="text-xs font-medium text-text-muted italic line-clamp-2">{{ d.currentDescription }}</p>
                }
            </div>
            @if(d.currentClosable) {
            <button (click)="closeDialog(d.id)"
                class="w-10 h-10 flex items-center justify-center rounded-xl border border-foreground/[0.08] text-foreground/40 hover:text-primary hover:border-primary/40 hover:bg-primary/5 transition-all">
                <iconify-icon icon="solar:close-square-bold-duotone" width="24" height="24"></iconify-icon>
            </button>
            }
        </div>
        }

        <div class="flex-1 overflow-auto p-4" [ngClass]="d.config.contentClass">
            <ng-container *ngComponentOutlet="d.component; injector: d.injector; inputs: d.config.data"></ng-container>
        </div>
    </div>
</div>
}
}